/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ExpensesInputs */

const vi_nav_expenses = /** @type {(inputs: Nav_ExpensesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoản chi`)
};

/**

* @param {Nav_ExpensesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_expenses = /** @type {((inputs?: Nav_ExpensesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ExpensesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_expenses(inputs)
});